import React, { Component } from "react";
import Fact from "./fact";
import EzSlider from "../../ezSlider";
class CircleFacts extends Component {
  constructor(props) {
    super(props);
    this.state = {
      factoid: [],
      config: [],
      nodeid: [],
      loading: true,
      error: false
    };
  }

  /* */
  componentDidMount() {
    const url =
      "https://www.uvm.edu/content/shared/api/v1.0/factoids?filter[display]=" +
      this.props.factoid;
    fetch(url)
      .then(response => {
        return response.json();
      })
      .then(data => {
        this.setState({
          factoid: data.data
        });
      })
      .catch(error => this.setState({ loading: false, error }));
  }
  /* */
  renderItems() {
    return this.state.factoid.map(item => (
      <div key={item.id} className="Slide" tabIndex="-1">
        <Fact item={item} />
      </div>
    ));
  }
  /* */
  render() {
    if (this.state.config) {
      return (
        <div style={this.props.style} tabIndex="-1" className="factoidBlock">
          <EzSlider
            slides={this.renderItems()}
            navColor="#01533F"
            hoverColor="#fff"
            instanceID={this.props.instanceID}
            settings={{
              className: "center",
              centerMode: true,
              infinite: true,
              arrowNav: {
                useArrow: true,
                arrowStyles: {
                  position: "absolute",
                  zIndex: "4444"
                },
                right: "10px",
                left: "10px",
                top: "216px"
              },
              speed: 500,
              slidesToShow: 1,
              slidesToScroll: 1,
              initialSlide: 0,
              swipeToSlide: true,
              maxWidth: 313,
              minWidth: 313
            }}
          />
        </div>
      );
    } else {
      return <p>Loading...</p>;
    }
  }
}

export default CircleFacts;
